module.exports = {
      id: "user-usage",
      viewBox: "0 0 13.8 17",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#user-usage",
      toString: function () {
        return this.url;
      }
    }